import { rdbV1FiltersConferencesList, v1SitesList } from '@on3/api';
import type { IGenericPageProps } from '@on3/ui-lib/api/schema/custom-contracts';
import withAuthentication from '@on3/ui-lib/src/hocs/withAuthentication';
import withValidUrl from '@on3/ui-lib/src/hocs/withValidUrl';
import { getFulfilledValue, proxyApi } from '@on3/ui-lib/utils/api';
import { PageWrapper } from 'components/Layouts/PageWrapper';
import { RightSidebarLayout } from 'components/Layouts/RightSidebarLayout';
import { StandardSidebar } from 'components/Layouts/StandardSidebar';
import { Colleges, type ICollegeProps } from 'components/Teams/Colleges';
import type { GetServerSideProps } from 'next';

interface ICollegePageProps extends IGenericPageProps, ICollegeProps {}

const CollegePage = (props: ICollegePageProps) => {
  const title = 'College Sports Channels - Comprehensive Coverage | On3.com';
  const description =
    'Explore On3.com for an extensive list of college sports channels. Dive into the latest transfer portal and NIL news, updates, and community content from top NCAA teams and sports leagues.';

  return (
    <PageWrapper {...props} description={description} title={title}>
      <RightSidebarLayout>
        <Colleges {...props} />
        <StandardSidebar />
      </RightSidebarLayout>
    </PageWrapper>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const siteData = await withValidUrl.isValid(ctx);
  const userData = await withAuthentication.isAuth(ctx);

  if (!siteData) {
    return {
      notFound: true,
    };
  }

  try {
    const params = {
      year: siteData?.defaultYears?.footballSeasonYear,
      sportKey: 1,
    };
    const [conferences, sites] = await Promise.allSettled([
      rdbV1FiltersConferencesList(proxyApi, params),
      v1SitesList(proxyApi, {}),
    ]);

    const data = {
      pageType: 'category',
      siteData,
      userData: userData || {},
      conferences: getFulfilledValue(conferences),
      sites: getFulfilledValue(sites),
    };

    return { props: { ...data } };
  } catch (e) {
    return { props: {} };
  }
};

export default withValidUrl(CollegePage);
